import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { useQueryParams } from '@hooks/queryParams';
import { UsersDropdownRespSuccess } from '@services/dropdowns/types';
import { PanelUsersDropdownProps } from './types';

export const usePanelUsersDropdown = ({ primaryRole }: PanelUsersDropdownProps) => {
  const {
    admin: { isLogged },
  } = useAppContext();
  const { tenantId } = useParams();
  const { parseParams } = useQueryParams();
  const { panel } = usePanel();
  const queryParams = parseParams({
    primaryRole,
    tenantId,
  });

  const { data, error, isPending } = useQuery<UsersDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.panel.users, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/users${queryParams}`, panel }),
    placeholderData: (previousData) => previousData as UsersDropdownRespSuccess,
    enabled: !!tenantId && isLogged && panel,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && !!tenantId && isLogged && panel,
  };
};
